import { useEffect, useState } from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import { useOnlineStatus } from "../hooks/useOnlineStatus";
import { getQueue } from "../lib/offlineStore";
import { syncPendingInspections } from "../lib/syncManager";

export const OfflineBanner = () => {
  const online = useOnlineStatus();
  const [queueLen, setQueueLen] = useState(getQueue().length);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const update = () => setQueueLen(getQueue().length);
    window.addEventListener("offline-queue-changed", update);
    return () => window.removeEventListener("offline-queue-changed", update);
  }, []);

  useEffect(() => {
    if (online && queueLen > 0) {
      setSyncing(true);
      syncPendingInspections().finally(() => {
        setQueueLen(getQueue().length);
        setSyncing(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [online]);

  if (online && queueLen === 0) return null;

  return (
    <div
      data-testid="offline-banner"
      className={`w-full text-center text-xs font-mono uppercase tracking-widest py-1.5 px-3 print:hidden ${
        !online ? "bg-amber-500/15 text-amber-300 border-b border-amber-600/40" : "bg-cyan-500/10 text-cyan-300 border-b border-cyan-600/40"
      }`}
    >
      {!online ? (
        <span className="flex items-center justify-center gap-1.5">
          <WifiOff className="w-3.5 h-3.5" /> Hors ligne{queueLen > 0 ? ` — ${queueLen} inspection(s) en attente de synchronisation` : ""}
        </span>
      ) : (
        <span className="flex items-center justify-center gap-1.5">
          <RefreshCw className={`w-3.5 h-3.5 ${syncing ? "animate-spin" : ""}`} /> {syncing ? "Synchronisation en cours..." : `${queueLen} inspection(s) en attente`}
        </span>
      )}
    </div>
  );
};
